import store from '@/store'

const checks = {
  errorMessage: {
    role: 'need roles! Like v-role="[\'admin\',\'editor\']" or v-role="\'admin\'"',
    permission: 'need permissions! Like v-permission="[\'add\',\'delete\']" or v-permission="\'add\'"'
  },
  userField: {
    permission: 'permissions'
  }
}

function checkItemPresented (value) {
  const presentedValues = store.getters.permissions || []
  return presentedValues.includes(value)
}

function checkingItemsPresented (checkingItems) {
  for (const checkItem of checkingItems) {
    if (!checkItemPresented(checkItem)) {
      return false
    }
  }
  return true
}

function checkElement (el, value, checkType) {
  let checkingItems

  if (typeof value === 'string') {
    checkingItems = [value]
  } else if (value instanceof Array && value.length > 0) {
    checkingItems = value
  } else {
    throw new Error(checks.errorMessage[checkType])
  }

  const valuePermitted = checkingItemsPresented(checkingItems)

  if (!valuePermitted) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}

const installPermissions = function (app) {
  app.directive('permission', {
    mounted (el, binding) {
      checkElement(el, binding.value, 'permission')
    }
  })
  app.mixin({
    methods: {
      hasPermission (name) {
        if (!name) {
          return false
        }
        return checkItemPresented(name, 'permission')
      }
    }
  })
}

export default installPermissions
